import { InviteEmailForm } from './InviteEmailForm';
import { OrganizationInviteList } from './OrganizationInviteList';
import { ShareInviteDialog } from './ShareInviteDialog';
import { useInviteShares } from './useInviteShares';

interface OrganizationInvitesProps {
  organizationId: string;
  /**
   * When false the pending rows render without a revoke button. Resolved by
   * the caller from its own authority model — see
   * {@link OrganizationInviteList}.
   */
  canRevoke: boolean;
  /** `data-tutorial-id` for the send button — see {@link InviteEmailForm}. */
  tutorialId?: string;
}

/**
 * Invite-by-email surface for one organization: the send form, the pending
 * list, and the one-time share dialog both of them feed.
 *
 * The org-facing members page composes these three pieces itself so the send
 * form can live in the "Add member" dialog; this wrapper is the single-panel
 * arrangement the admin org detail page uses.
 */
export function OrganizationInvites({
  organizationId,
  canRevoke,
  tutorialId,
}: OrganizationInvitesProps) {
  const { shares, addShares, clearShares } = useInviteShares();

  return (
    <div className="space-y-4">
      <InviteEmailForm
        organizationId={organizationId}
        tutorialId={tutorialId}
        onInvited={addShares}
      />

      <div className="border-t border-border pt-4">
        <p className="mb-3 text-sm font-medium">Open invites</p>
        <OrganizationInviteList
          organizationId={organizationId}
          canRevoke={canRevoke}
          onShare={(share) => addShares([share])}
        />
      </div>

      <ShareInviteDialog shares={shares} onClose={clearShares} />
    </div>
  );
}
